"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyTreeItem = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const icons_material_1 = require("@mui/icons-material");
const classnames_1 = __importDefault(require("classnames"));
const tree_item_content_component_1 = require("./tree-item-content.component");
const tree_item_styles_1 = require("./tree-item.styles");
const use_highlight_created_node_hook_1 = require("../hooks/use-highlight-created-node.hook");
const use_tree_node_filtering_hook_1 = require("../hooks/use-tree-node-filtering.hook");
const attributes_1 = require("../../../client/attributes");
const product_tree_node_1 = require("../../../client/product-tree-node");
const context_1 = require("../../../context");
const generic_1 = require("../../../generic");
const hooks_1 = require("../../../hooks");
const store_1 = require("../../../../store");
const StrategyTreeItem = react_1.default.forwardRef(function CustomTreeItem({ treeNode, parentPath, isNodeChanged, allowedNodeIds, hasAttributeFilter, actionsEnabled, onAction, }, ref) {
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const { getTreeNodeDisplayNameByTitle } = (0, hooks_1.useTreeNodeDisplayName)();
    const { shouldShowNodeInTree } = (0, use_tree_node_filtering_hook_1.useTreeNodeFiltering)();
    const { highlightedNodeId } = (0, use_highlight_created_node_hook_1.useNodeHighlightContext)();
    const { isInEnrichmentHierarchy } = (0, context_1.useCatalogActivityProgressContext)();
    const { parentNode, children: treeNodeChildren, id, descendants, description, productPresentationsNew, title, } = treeNode;
    const { data, loading, getProductTreeNodeWithChildren, } = (0, product_tree_node_1.useProductTreeNodeWithChildren)();
    const rootParent = !parentNode;
    const hasChildren = (descendants === null || descendants === void 0 ? void 0 : descendants.totalCount) > 1;
    const terminalNode = !hasChildren;
    const path = `${parentPath}${store_1.STRATEGY_NODE_PATH_SEPARATOR}${id}`;
    const isRootNode = parentPath.split(store_1.STRATEGY_NODE_PATH_SEPARATOR).length === 1;
    const { checkIsNodeChanged } = (0, hooks_1.useStrategyNodeChanges)();
    const loadedChildren = (0, react_1.useMemo)(() => { var _a; return (_a = data === null || data === void 0 ? void 0 : data.productTreeNode) === null || _a === void 0 ? void 0 : _a.children; }, [data]);
    const { totalCount } = productPresentationsNew !== null && productPresentationsNew !== void 0 ? productPresentationsNew : {};
    const children = treeNodeChildren || loadedChildren;
    const handleExpand = (0, react_1.useCallback)(() => {
        if (hasChildren && !children && !loading) {
            void getProductTreeNodeWithChildren({
                variables: {
                    catalogId: selectedCatalogId,
                    nodeId: id,
                },
            });
        }
    }, [children, getProductTreeNodeWithChildren, hasChildren, id, loading, selectedCatalogId]);
    const _a = (0, generic_1.useTooltip)(), { onMouseEnter } = _a, tooltipWrapperProps = __rest(_a, ["onMouseEnter"]);
    const ContentSlot = (0, react_1.useMemo)(() => react_1.default.forwardRef(function StrategyTreeItemContentSlot(props, contentRef) {
        return react_1.default.createElement(tree_item_content_component_1.TreeItemContent, Object.assign(Object.assign({}, props), { ref: contentRef, onExpand: handleExpand, isChanged: isNodeChanged }));
    }), [handleExpand, isNodeChanged]);
    const renderedChildren = (0, react_1.useMemo)(() => {
        if (terminalNode)
            return null;
        if (hasChildren && !children)
            return react_1.default.createElement("div", null);
        // Only apply filtering if allowedNodeIds has actual values
        const shouldFilter = allowedNodeIds && allowedNodeIds.length > 0;
        const childrenToProcess = shouldFilter
            ? children.filter((child) => allowedNodeIds.includes(child.id))
            : children;
        return childrenToProcess.reduce((acc, child) => {
            var _a;
            const childPath = `${path}.${child.id}`;
            const isChanged = checkIsNodeChanged(childPath);
            const hasManuallySelectedNodes = shouldFilter && !hasAttributeFilter;
            if (!hasManuallySelectedNodes) {
                const shouldShowNode = shouldShowNodeInTree(child.id, {
                    isChanged,
                    hasContent: (_a = child.productPresentationsNew) === null || _a === void 0 ? void 0 : _a.totalCount,
                    hasManualSelection: hasManuallySelectedNodes,
                    ignoreManualVisibility: hasAttributeFilter,
                });
                if (!shouldShowNode)
                    return acc;
            }
            acc.push(react_1.default.createElement(StrategyTreeItem, { key: childPath, treeNode: child, parentPath: path, isNodeChanged: isChanged, allowedNodeIds: allowedNodeIds, hasAttributeFilter: hasAttributeFilter, actionsEnabled: actionsEnabled, onAction: onAction }));
            return acc;
        }, []);
    }, [
        terminalNode,
        hasChildren,
        children,
        allowedNodeIds,
        hasAttributeFilter,
        path,
        checkIsNodeChanged,
        shouldShowNodeInTree,
        actionsEnabled,
        onAction,
    ]);
    const formattedTitle = getTreeNodeDisplayNameByTitle(title);
    const treeItemNode = (0, react_1.useMemo)(() => ({
        id,
        title,
        description,
        isTerminalNode: terminalNode,
        totalProductsCount: totalCount !== null && totalCount !== void 0 ? totalCount : 0,
        path,
    }), [id, title, description, terminalNode, totalCount, path]);
    const isHighlighted = highlightedNodeId === id;
    const shouldShowReEnrichIcon = (0, react_1.useMemo)(() => isInEnrichmentHierarchy(path), [isInEnrichmentHierarchy, path]);
    return (react_1.default.createElement(tree_item_styles_1.StyledTreeItem, { ref: ref, slots: Object.assign({ expandIcon: icons_material_1.ChevronRight, collapseIcon: icons_material_1.ExpandMore, content: ContentSlot }, (loading ? { icon: tree_item_styles_1.StyledProcessingSpinner } : {})), slotProps: {
            expandIcon: { color: 'primary', fontSize: 'large' },
            collapseIcon: { color: 'primary', fontSize: 'large' },
        }, className: (0, classnames_1.default)({
            'root-parent': rootParent,
            'terminal-node': terminalNode,
            'node--disabled': loading,
            'node--highlighted': isHighlighted,
        }), "data-node-id": id, itemId: path, label: react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(generic_1.TooltipWrapper, Object.assign(Object.assign({}, tooltipWrapperProps), { title: formattedTitle, enterDelay: 5000 }), react_1.default.createElement(tree_item_styles_1.StyledTitle, null, react_1.default.createElement(ui_components_1.Typography, { onMouseEnter: onMouseEnter, className: (0, classnames_1.default)('node-title', { 'root-node-title': isRootNode }), accent: true }, formattedTitle), react_1.default.createElement(ui_components_1.Typography, { variant: "caption", color: "textSecondary", className: "node-total-count" }, totalCount !== null && totalCount !== void 0 ? totalCount : 0), actionsEnabled && !shouldShowReEnrichIcon && (react_1.default.createElement("div", { className: "tree-node-menu-button" }, title !== attributes_1.UN_CATEGORIZED_NODE_TITLE
            ? react_1.default.createElement(tree_item_styles_1.StyledTreeNodeMenuButton, { size: "small", onClick: (event) => onAction === null || onAction === void 0 ? void 0 : onAction(event, treeItemNode) }, react_1.default.createElement(ui_components_1.Icon, { size: "small", variant: "moreVertical" }))
            : null)), shouldShowReEnrichIcon && (react_1.default.createElement(tree_item_styles_1.StyledReloadIcon, null))))) }, renderedChildren));
});
const MemoizedTreeItem = react_1.default.memo(StrategyTreeItem);
exports.StrategyTreeItem = MemoizedTreeItem;
exports.default = MemoizedTreeItem;
